import init from 'src/lib/init.js'

init()
